import React from "react";
import { easing } from "maath";

const ProgressBar = ({ moneyRaised: _moneyRaised }: { moneyRaised: number }) => {
  const GOAL = 1200000; // $1.2 million in dollars
  const raised = 1449570; // hard-coded total raised, exceeding goal
  const progress = Math.min((raised / GOAL) * 100, 100);
  const isStartOfCampaign = progress < 20;

  const formatGoal = (dollars: number) => {
    if (dollars >= 1000000) return `$${(dollars / 1000000).toFixed(1)}M`;
    return `$${Math.round(dollars / 1000)}k`;
  };

  const formatRaised = (dollars: number) => `$${dollars.toLocaleString("en-US")}`;

  return (
    <div className="progress-bar">
      <div className="progress-bar-meter">
        <div className="progress-bar-mask" style={{ width: `${100 - progress}%` }}></div>
        <span
          className={`progress-bar-raised text-size-small ${isStartOfCampaign ? "progress-bar-raised--start" : ""}`}
          style={{ left: `${Math.min(progress, 100)}%` }}
        >
          {/* {formatRaised(raised)} */}
          $39,777,985
        </span>
      </div>
      <span className="progress-bar-total text-size-small">$40M</span>
    </div>
  );
};

export { ProgressBar };
